'use client';


import Icon from '@/components/ui/AppIcon';
import { useLanguage } from '@/contexts/LanguageContext';

const FloatingConsultationCTA = () => {
  const { language } = useLanguage();
  const isRTL = language === 'ar';

  const handleWhatsAppClick = () => {
    window.open('https://wa.me/966508003505', '_blank');
  };

  const content = {
    ar: {
      label: 'استشارة سريعة'
    },
    en: {
      label: 'Quick Consultation'
    }
  };

  const t = content?.[language];

  return (
    <button data-component-id="src/components/common/FloatingConsultationCTA.tsx:27:4" data-component-path="src/components/common/FloatingConsultationCTA.tsx" data-component-line="27" data-component-end-line="37" data-component-file="FloatingConsultationCTA.tsx" data-component-name="button" data-component-content="%7B%22elementName%22%3A%22button%22%2C%22className%22%3A%22fixed%20bottom-6%20left-6%20z-40%20px-6%20py-3%20bg-success%20text-success-foreground%20font-inter%20font-bold%20rounded-full%20shadow-lg%20hover%3Ashadow-xl%20transition-all%20duration-300%20hover%3Ascale-105%20flex%20items-center%20gap-2%22%7D"
      onClick={handleWhatsAppClick}
      className="fixed bottom-6 left-6 z-40 px-6 py-3 bg-success text-success-foreground font-inter font-bold rounded-full shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-105 flex items-center gap-2"
      dir={isRTL ? 'rtl' : 'ltr'}
    >
      <div data-component-id="src/components/common/FloatingConsultationCTA.tsx:32:6" data-component-path="src/components/common/FloatingConsultationCTA.tsx" data-component-line="32" data-component-end-line="35" data-component-file="FloatingConsultationCTA.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22relative%22%7D" className="relative">
        <Icon data-component-id="src/components/common/FloatingConsultationCTA.tsx:33:8" data-component-path="src/components/common/FloatingConsultationCTA.tsx" data-component-line="33" data-component-end-line="33" data-component-file="FloatingConsultationCTA.tsx" data-component-name="Icon" data-component-content="%7B%22elementName%22%3A%22Icon%22%2C%22name%22%3A%22ChatBubbleLeftRightIcon%22%7D" name="ChatBubbleLeftRightIcon" size={24} variant="solid" />
        <span data-component-id="src/components/common/FloatingConsultationCTA.tsx:34:8" data-component-path="src/components/common/FloatingConsultationCTA.tsx" data-component-line="34" data-component-end-line="34" data-component-file="FloatingConsultationCTA.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%2C%22className%22%3A%22absolute%20-top-1%20-right-1%20w-3%20h-3%20bg-success%20rounded-full%20animate-pulse%22%7D" className="absolute -top-1 -right-1 w-3 h-3 bg-success rounded-full animate-pulse" />
      </div>
      <span data-component-id="src/components/common/FloatingConsultationCTA.tsx:36:6" data-component-path="src/components/common/FloatingConsultationCTA.tsx" data-component-line="36" data-component-end-line="36" data-component-file="FloatingConsultationCTA.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%7D">{t?.label}</span>
    </button>
  );
};

export default FloatingConsultationCTA;